<template>
  <div></div>
</template>

<script>
export default {
  name: 'Return',
  props: {},
  data () {
    return {}
  },

  created () {
    window.opener.receiveParameters(this.$route.params.namespace, this.$route.query)
    window.close()
  },
  methods: {
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
